// leaders/teacher-detail
import React, { useCallback, useState } from 'react';
import View from 'src/pages/leaders/teachers/detail';
import AppRender from 'src/routes/app-render';
import { useForm } from 'src/hooks/use-form';
import { teacherStaffApi } from 'src/api/staffs/vm-teacher';
import { carsApi } from 'src/api/cars/vm-view';
import { useOptions } from 'src/hooks/use-privileges';

const Page = () => {
  const { handleNavigate, itemNavigate } = useForm();
   const { single } = useOptions('xe'); 

  const [data, setData] = useState();
  const [options, setOptions] = useState([]);
  const fetchData = useCallback(async () => {
    if(itemNavigate){
      teacherStaffApi.getDetail(
        itemNavigate,
        (result) => {
          setData(result);
        },
      );
    }

    if(single){
      carsApi.getItemAssigned(
        single,
        (result) => {
          // result.push({label: 'Thu hồi', value: '0'});
          result.unshift({ label: 'Thu hồi', value: '0' });
          setOptions(result);
        }
      );
    }
  }, []);
  
  return (
    <AppRender apiCall={fetchData}>
      {data && <View onNavigate={handleNavigate} item={data} options={options} />}
    </AppRender>
  );
};

export default Page;
